import { mapValues, values, map, groupBy, orderBy, find, filter, reduce, min } from '@dt/fe-utils/dist/lodash'
import { plus, minus, times, halfUp, BigNumberStatic } from './number-util'
import * as NumberUntil from './number-util'

class Fee {
  private feeConfig: IFeeConfig = {
    gratuity: null,
    tip: null,
    taxConfig: {},
    cityId: 0
  }

  private taxConfig: {
    [cityCode: string]: {
      [diningOption: string]: {
        [productTaxCategory: string]: ITaxItemConfig;
      };
    };
  } = {}

  private taxIdMap: {
    [taxId: number]: ITaxItemConfig;
  } = {}

  init (feeConfig: IFeeConfig) {
    this.feeConfig = feeConfig
    this.taxConfig = feeConfig.taxConfig
    // if (feeConfig.tax) {
    //   // 转换fee配置到树形结构 cityCode -> diningOption -> productTaxCategory
    //   this.taxConfig = {}
    //   feeConfig.tax.forEach(tconfig => {
    //     const cityCodeOption = tconfig.taxOptionsList.find(taxoption => taxoption.type === 'cityCode')
    //     const productTaxCategoryOption = tconfig.taxOptionsList.find(taxoption => taxoption.type === 'productTaxCategory')
    //     const diningOptionOption = tconfig.taxOptionsList.find(taxoption => taxoption.type === 'diningOption')
    //     if (cityCodeOption && productTaxCategoryOption && diningOptionOption) {
    //       merge(this.taxConfig, {
    //         [cityCodeOption.targetId]: {
    //           [diningOptionOption.targetId]: {
    //             [productTaxCategoryOption.targetId]: pick(tconfig, 'name', 'rate', 'roundingOption', 'category', 'id')
    //           }
    //         }
    //       })
    //     }
    //   })
    //   // this.taxIdMap = keyBy(feeConfig.tax, 'id')
    // }
  }

  /**
   * { function_description }
   *
   * @param      { object }  [order={}]  The order
   * @return     { object }
   * {
   *   taxes,
   *   gratuities,
   *   taxInPrice,
   *   gratuityTaxes,
   *   gratuityTotal,
   *   taxTotal,
   *   freeTaxTotal,
   *   showTaxTotal,
   *   gratuityTaxTotal,
   *   total,
   *   subTotal
   * }
   */
  calculate (order: ICalcTaxAndServiceChargeData) {
    // 但是如果一个餐品含税则不能免税！！！
    // TODO 未区分服务费的免税
    const total = reduce(order.detail, (s, i) => (s = plus(s, i.paidPrice, 2)), 0)
    // 税
    const taxes = this.calTax(order, 'detail')
    // 费用税(配送费、打包费)
    const expenseTaxes = this.calTax(order, 'expense')
    // 服务费
    const gratuities = this.calGratuity(order)
    // 含税总
    const taxInPrice = filter(taxes, 'taxInPrice')
    const taxedGratuity = gratuities.filter((gratuity) => gratuity.taxed && gratuity.tax.amount)
    // 服务费的税
    const gratuityTaxes = taxedGratuity.map(gratuity => Object.assign(gratuity.tax, { isTaxFree: order.freeTaxList.includes(gratuity.tax.taxCategoryId) }))
    // 税总
    const taxTotal = this.calTaxTotal(taxes.concat(gratuityTaxes, expenseTaxes).filter(i => !i.isTaxFree) as any)
    // 免税总
    const freeTaxTotal = this.calTaxTotal(taxes.concat(gratuityTaxes, expenseTaxes).filter(i => i.isTaxFree) as any)
    // 含税总
    const showTaxTotal = this.calTaxTotal(taxInPrice as any)
    const taxOutPrice = this.calTaxTotal(filter(taxes.concat(gratuityTaxes, expenseTaxes), (i) => !i.taxInPrice) as any)

    return {
      taxOutPrice: min([taxOutPrice, taxTotal - showTaxTotal]),
      taxes,
      expenseTaxes,
      gratuities,
      taxInPrice,
      gratuityTaxes,
      gratuityTotal: reduce(gratuities, (s, i) => (s = plus(s, i.amount, 2)), 0),
      taxTotal,
      freeTaxTotal,
      showTaxTotal,
      gratuityTaxTotal: reduce(gratuityTaxes, (s, i) => (s = plus(s, i.amount, 2)), 0),
      expenseTaxTotal: reduce(expenseTaxes, (s, i) => (s = plus(s, i.amount, 2)), 0),
      total,
      subTotal: minus(total, showTaxTotal, 2)
    }
  }

  tip (tipOption: any = {}) {
    const { diningOption, clientType, total, tax } = tipOption
    const tip = this.feeConfig.tip
    const simpleResult: any[] = []
    const defaultResult: any[] = []
    map(tip, e => {
      const _diningOptions = e.diningOptions.map((item: any) => item.toLowerCase())
      const _diningOption = `${diningOption}${clientType}`.toLowerCase()
      if (_diningOptions.includes(_diningOption)) {
        let data = {
          type: e.type,
          name: e.description,
          amount: 0
        } as any

        if (e.calByAmount && e.mode === 'simple' && e.calAmountMax > total) {
          data.amount = e.value
          simpleResult.push(data)
        } else if (e.mode === 'default') {
          data.percent = times(e.value, 0.01, 4)
          data.amount = halfUp(BigNumberStatic(total).plus(e.taxInAmount ? tax : 0).times(e.value).times(0.01))
          defaultResult.push(data)
        }
      }
    })

    return simpleResult.length ? simpleResult : defaultResult
  }

  refund (total = 0, order: any = {}) {
    const { tax = 0, paidFee = 0 } = order

    const paidFeeTotal = BigNumberStatic(tax).plus(paidFee)
    const taxRate = halfUp(paidFeeTotal) ? BigNumberStatic(tax).div(paidFeeTotal) : BigNumberStatic(0)
    const reFundTax = BigNumberStatic(total).times(taxRate)
    const reFundFee = BigNumberStatic(total).minus(reFundTax)

    return {
      tax: halfUp(reFundTax),
      fee: halfUp(reFundFee)
    }
  }

  calTax (order: ICalcTaxAndServiceChargeData, key: 'detail' | 'expense') {
    const result: {
      pk: string;
      productNo: string;
      taxId: number;
      rate: number;
      taxName: string;
      taxInPrice: boolean;
      roundingOption: 'halfUp' | 'halfEven' | 'alwaysDown' | 'alwaysUp';
      amount: number;
      isTaxFree: boolean;
      taxCategoryId: number;
      cnt: number;
    }[] = []
    if (!order.detail.length) {
      return result
    }
    const quantityItems = order.detail.filter(i => !i.isComboChild)
    const sameTaxMap = groupBy(quantityItems, orderItem => orderItem.taxCategoryId)
    const sameProductMap = groupBy(quantityItems, orderItem => orderItem.productNo)
    order?.[key]?.forEach(orderItem => {
      const taxConfigItem = this.getTaxItemConfig(order.cityId, order.diningOption, orderItem.taxCategoryId)
      const isTaxFree = order.freeTaxList.includes(orderItem.taxCategoryId) || order.freeTaxList[0] === -1
      const sameTaxCnt = reduce(sameTaxMap?.[orderItem.taxCategoryId], (n, i) => n + i.cnt, 0)
      const sameProductCnt = reduce(sameProductMap?.[orderItem.productNo], (n, i) => n + i.cnt, 0)
      if (taxConfigItem) {
        const { rate, id: taxId, name: taxName, roundingOption, taxCategoryId } = taxConfigItem
        const quantity = taxConfigItem.extra?.quantity
        let quantityRate
        if (quantity && !orderItem.isComboChild) {
          let calcCnt: any = quantity.isGroup ? sameTaxCnt : sameProductCnt
          if (calcCnt >= quantity.cnt) {
            quantityRate = quantity.rate
          }
        }
        const item = {
          pk: orderItem.pk,
          productNo: orderItem.productNo,
          taxId,
          rate,
          taxName,
          taxInPrice: orderItem.taxInPrice,
          roundingOption,
          amount: this.calTaxItem(orderItem.paidPrice, order.cityId, order.diningOption, orderItem.taxCategoryId, orderItem.taxInPrice, quantityRate).amount,
          isTaxFree,
          taxCategoryId,
          cnt: orderItem.cnt,
          quantityRate
        }
        result.push(item)
      }
    })
    return result
  }

  /**
   * private method dinfinition
   */
  calGratuity (order: ICalcTaxAndServiceChargeData) {
    const result: any[] = []
    if (!this.feeConfig?.gratuity?.items?.length) {
      return result
    }
    const person = order.person
    const gratuities = groupBy(this.feeConfig.gratuity.items, 'type')
    const discounted = this.feeConfig.gratuity.discounted
    const detail = (order.detail || []).concat(order.expense?.filter(i => ['box'].includes(i.type)) || [])
    const paidPrice = reduce(detail, (s, i) => (s = plus(s, i.paidPrice, 2)), 0)
    const originalPrice = reduce(detail, (s, i) => (s = plus(s, i.originalPrice, 2)), 0)
    map(gratuities, (value: any, key) => {
      if (key === 'person') {
        value = orderBy(value, e => {
          return parseInt(e.applyRange)
        }, ['asc'])

        const personTypeGratuity = find(value, (e, i, r) => {
          let p = person
          let start = parseInt(e.applyRange)
          let end = r[i + 1] ? parseInt(r[i + 1].applyRange) : null
          return end ? p >= start && p < end : p >= start
        })

        let data: any = null
        if (paidPrice >= 0 && originalPrice >= 0 && personTypeGratuity) {
          data = {
            id: personTypeGratuity.id,
            name: personTypeGratuity.name,
            type: key,
            applyRange: parseInt(personTypeGratuity.applyRange),
            value: personTypeGratuity.value,
            amount: halfUp(BigNumberStatic(discounted ? paidPrice : originalPrice).times(personTypeGratuity.value).times(0.01)),
            taxed: personTypeGratuity.taxed,
            tax: null
          }
        }
        if (paidPrice >= 0 && originalPrice >= 0 && personTypeGratuity && personTypeGratuity.taxed) {
          data.tax = this.calTaxItem(data.amount, order.cityId, order.diningOption, personTypeGratuity.productTaxCategoryId)
          data.isTaxFree = order.freeTaxList.includes(personTypeGratuity.productTaxCategoryId)
        }

        if (data) {
          result.push(data)
        }
      } else if (key === 'percent') {
        map(value, e => {
          const data = {
            id: e.id,
            name: e.name,
            type: key,
            applyRange: e.applyRange,
            value: e.value,
            amount: halfUp(BigNumberStatic(discounted ? paidPrice : originalPrice).times(e.value).times(0.01)),
            taxed: e.taxed,
            tax: null as any,
            isTaxFree: false
          }

          if (e.taxed) {
            data.tax = this.calTaxItem(data.amount, order.cityId, order.diningOption, e.productTaxCategoryId)
            data.isTaxFree = order.freeTaxList.includes(e.productTaxCategoryId)
          }

          result.push(data)
        })
      } else if (key === 'amount') {
        map(value, async e => {
          const data = {
            id: e.id,
            name: e.name,
            type: key,
            applyRange: e.applyRange,
            value: e.value,
            amount: halfUp(e.value),
            taxed: e.taxed,
            tax: null as any,
            isTaxFree: false
          }

          if (e.taxed) {
            data.tax = this.calTaxItem(data.amount, order.cityId, order.diningOption, e.productTaxCategoryId)
            data.isTaxFree = order.freeTaxList.includes(e.productTaxCategoryId)
          }

          result.push(data)
        })
      } else {
        return result
      }
    })
    return result
  }

  private getTaxItemConfig (cityId: number, diningOption: string, taxCategoryId: number) {
    diningOption = diningOption.toLowerCase()
    const cityIdStr = cityId.toString()
    const taxCategoryIdStr = taxCategoryId && taxCategoryId.toString()
    const taxDiningOptionConfig = this.taxConfig[cityIdStr] && this.taxConfig[cityIdStr][diningOption]
    return taxDiningOptionConfig && (taxDiningOptionConfig['-1'] || taxDiningOptionConfig[taxCategoryIdStr])
  }

  calTaxByProduct (tax: any, price: number) {
    return (NumberUntil as any)[tax.roundingOption || 'halfUp'](BigNumberStatic(price).times(tax.rate), 7)
  }

  private calTaxItem (price: number, cityId: number, diningOption: string, taxCategoryId: number, taxInPrice = false, quantityRate?: number) {
    const tax = this.getTaxItemConfig(cityId, diningOption, taxCategoryId)
    if (tax) {
      const rate = quantityRate !== undefined ? quantityRate : tax.rate
      return {
        taxId: tax.id,
        rate: rate,
        taxName: tax.name,
        category: tax.category,
        roundingOption: tax.roundingOption,
        taxInPrice,
        taxCategoryId,
        amount: (NumberUntil as any)[tax.roundingOption || 'halfUp'](taxInPrice ? BigNumberStatic(price).minus(BigNumberStatic(price).div(BigNumberStatic(rate).plus(1))) : BigNumberStatic(price).times(rate), 7)
      }
    } else {
      return {
        amount: 0
      }
    }
  }

  calTaxTotal (taxes = []) {
    const groupByRounding = groupBy(taxes, 'roundingOption')
    const sumByRounding = mapValues(groupByRounding, (e, k) => (NumberUntil as any)[k || 'halfUp'](reduce(e, (s, i: any) => (s = plus(s, i.amount)), 0), 2))
    const taxSum = values(sumByRounding)
    const taxTatal = reduce(taxSum, (s, i) => (s = plus(s, i, 2)), 0)
    return taxTatal
  }

  getTaxConfig () {
    return this.taxConfig
  }
}

export default new Fee()
